import PrintTags from "./components/printTags/PrintTags";
import OpenPull from "./components/openPulls/OpenPull";
import EcomOrders from "./components/ecomOrders/EcomOrders";
import FramePick from "./components/framePick/FramePick";
import SpecialOrderQueue from "./components/framePick/SpecialOrderQueue/SpecialOrderQueue";
import Vendor from "./components/vendor/Vendor";
import DailyOrders from "./components/orderStatus/DailyOrders";
import OrderStatus from "./components/orderStatus/OrderStatus";
import AccessoryReplenishment from "./components/systemPreference/AccessoryReplenishment";
import KitMaintenance from "./components/kits/kitMaintenance/KitMaintenance";
import NewStyleKit from "./components/kits/kitMaintenance/NewStyleKit";
import FrameArrangerQty from "./components/FrameArranger/FrameArrangerQty/FrameArrangerQty";
import styles from "./components/navbar/navbarMenu.module.scss";
import VendorsAndCollection from "./components/FrameArranger/VendorsAndCollections/VendorsAndCollection";
import ProductPlanogram from "./components/FrameArranger/ProductPlanogram/ProductPlanogram";
import OfficeCollectionMapping from "./components/FrameArranger/OfficeCollection/OfficeCollectionMapping";
import { reactApp } from "./util/constants/common.constants";
import ValidateAcuityFrameImport from "./components/FrameArranger/ValidateAcuityFrameImport/ValidateAcuityFrameImport";
import KitProcessing from "./components/kits/KitProcessing/KitProcessing";
import ProcessNewKit from "./components/kits/KitProcessing/ProcessNewKit";
import KitDetailPage from "./components/kits/kitMaintenance/KitDetailPage";
import FedEx from "./components/FedEx/Fedex/FedEx";
import ExpressOffices from "./components/FedEx/ExpressOffices/ExpressOffices";
import Dashboard from "./components/Dashboard/Dashboard";
import Unauthorized from "./components/unauthorized/unauthorized";
import BulkCostUpdate from "./components/bulkCostUpdate/BulkCostUpdate";
import OfficeReplenishmentPO from "./components/officeReplenishmentPO/officeReplenishmentPO";
import { LocationListUpdate } from "./components/inventotyAudit/LocationList/LocationListUpdate";
import { InventoryUpdate } from "./components/inventotyAudit/InventoryUpdate/InventoryUpdate";
import { ReplenishmentJobUpdate } from "./components/ReplenishmentJobUpdate/ReplenishmentJobUpdate";
import  UndoInventoryPost  from "./components/inventotyAudit/UndoInventoryPost/UndoInventoryPost";
import MoveToFtpFolder from "./components/FtpFileTransfer/MoveToFtpFolder";
import UploadToFtpFolder from "./components/FtpFileTransfer/UploadToFtpFolder";



const routes = [
    {
        path: "/dashboard",
        title: "Dashboard",
        content: () => <Dashboard />,
    },
    {
        title: "Frame Pick",
        children: [
            {
                path: "/framePickQueue",
                title: "Frame Pick Queue",
                content: () => <FramePick />,
            },
            {
                path: "/specialOrderQueue",
                title: "Special Order Queue",
                content: () => <SpecialOrderQueue />,
            },
        ],
    },
    {
        title: "Replenishment",
        children: [
           {
               path: "/officereplenishmentpo",
               title: "Office",
                content: () => <OfficeReplenishmentPO />,
            },
            {
                path: "/replenishmentPreferences",
                title: "Accessories",
                content: () => <AccessoryReplenishment />,
            },
        ],
    },
    {
        title: "Frame Arranger",
        children: [
            {
                path: "/vendorsCollectionsMapping",
                title: "Vendors to Collections Mapping",
                content: () => <VendorsAndCollection />,
            },
            {
                path: "/assortmentManagement",
                title: "Assortment Management",
                content: () => <FrameArrangerQty />,
            },
            {
                path: "/officeCollectionsMapping",
                title: "Office Planograms",
                content: () => <OfficeCollectionMapping />,
            },
            {
                path: "/productPlanogram",
                title: "Product Planogram",
                content: () => <ProductPlanogram />,
            },
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FRAME_ItemImportIntoAcuity",
                title: "Planogram Export",
            },
            {
                path: "/ValidateAcuityFrameImport",
                title: "Validate Acuity Frame Import",
                content: () => <ValidateAcuityFrameImport />,
            },
        ],
    },
    {
        title: "New Style Kits",
        children: [
            {
                path: "/kitMaintenance",
                title: "Kit Maintenance",
                content: () => <KitMaintenance />,
            },
            {
                path: "/KitProcessing",
                title: "Kit Processing",
                content: () => <KitProcessing />,
            },
        ],
    },
    {
        path: "/newKit",
        title: "",
        content: () => <NewStyleKit />,
    },
    {
        path: "/processNewKit",
        title: "",
        content: () => <ProcessNewKit />,
    },
    {
        path: "/kitDetailPage",
        title: "",
        content: () => <KitDetailPage />,
    },
    {
        title: "Reports",
        children: [
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FrameArrangerLocationInventoryTransfers",
                title: "Frame Arranger - Location Inventory Transfers",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FrameArrangerLocationOnHandInventory",
                title: "Frame Arranger - Location On Hand Inventory",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FrameArrangerLocationVendorCollection",
                title: "Frame Arranger - Location Vendor Collection",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "Replenishment Reports/ReplenishmentStockTransfer",
                title: "Frame Arranger - Replenishment Stock Transfer",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "Replenishment Reports/ReplenishmentVendorOrder",
                title: "Frame Arranger - Replenishment Vendor Order",
            },
            {
                path:
                    reactApp().reportDomainName + "FreezeFramePickQueue",
                title: "Canceled Frame Pick Orders",
            },
            {
                path:
                    reactApp().reportDomainName + "30-Day%20Turn%20Time",
                title: "30 Day Turn Around Time",
            },
            {
                path:
                    reactApp().reportDomainName + "InvalidOfficeTransfers",
                title: "Invalid Transfers",
            },
            {
                path:
                    reactApp().reportDomainName + "ArrangerPlanogramCompare",
                title: "Arranger Planogram Compare",
            },
            {
                path:
                    reactApp().reportDomainName + "Location%20On%20Hand%20Inventory",
                title: "Location On Hand Inventory",
            },
            {
                path:
                    reactApp().reportDomainName + "Transfers_All_Detail",
                title: "Transfers All Detail",
            },
            {
                path:
                    reactApp().reportDomainName + "Vendor%20Receipt",
                title: "Vendor Receipt",
            },
        ],
    },
    {
        title: "Utilities",
        children: [
            {
                path: "/expressOffices",
                title: "FedEx Express Offices",
                content: () => <ExpressOffices />,
            },
            {
                path: "/fedex",
                title: "FedEx Shipping Labels",
                content: () => <FedEx />,
            },
            {
                path: "/openPull",
                title: "Open Pull",
                content: () => <OpenPull />,
            },
            {
                path: "/ecomOrders",
                title: "Ecom Orders",
                content: () => <EcomOrders />,
            },
            {
                path: "/printTags",
                title: "Print Little Tags",
                content: () => <PrintTags />,
            },
            {
                path: "/orders",
                title: "View Orders",
                content: () => <OrderStatus />,
            },
            {
                path: "/vendor",
                title: "Vendor Assignment",
                content: () => <Vendor />,
            },
            {
                path: "/orderSearch",
                title: "Update Order Status",
                content: () => <DailyOrders />,
            },
            {
                path: "/bulkCostUpdate",
                title: "Bulk Cost Update",
                content: () => <BulkCostUpdate />,
            },
            {
                path: "/replenishmentJobConfiguration",
                title: "Replenishment Job Configuration",
                content: () => <ReplenishmentJobUpdate />,
            }
        ],
    },
    {
        title: "Quarterly DC Audit",
        children: [
            {
                path: "/locationList",
                title: "Location List Update",
                content: () => <LocationListUpdate />,
            },
            {
                path: "/finalInventoryUpdate",
                title: "Final Inventory Update",
                content: () => <InventoryUpdate />,
            },
            {
                path: "/undoInventoryPost",
                title: "Undo Inventory Post",
                content: () => <UndoInventoryPost />,
            }
        ],
    },
    {
        path: "/unauthorized",
        title: "",
        content: () => <Unauthorized />,
    },
    {
        path: "/moveToProcessPO",
        title: "Move To Process PO",
        content: () => <MoveToFtpFolder />,
    },
    {
        path: "/uploadToVendorPO",
        title: "Upload File To Vendor PO",
        content: () => <UploadToFtpFolder />,
    },
];

export default routes;
